import React from "react";

import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import classNames from "classnames";

import styles from "./index.module.less";

const LoadingProgress = () => {
  const icon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  return (
    <div className={classNames(styles.loadingProgress, "loading-progress")}>
      <Spin indicator={icon} />
    </div>
  );
};

export default LoadingProgress;
